import ChillersPortfolio from '@/Core.Service.Domain/Controls/Chillers/Views/IndexView.vue';

import EditChiller from '@/Core.Service.Domain/Controls/Chillers/Views/EditChiller.vue';

export const ChillersRoute = {
  path: 'chillers',
  name: 'ChillerPortfolio',
  component: ChillersPortfolio,
  children: [
    {
      path: 'history/:id',
      name: 'ChillerHistory',
    },
  ],
  meta: {
    placeholder: 'Search for a Chiller',
    controlTypeName: 'Chiller',
    label: 'Chiller',
    toolTip: 'Chiller',
    permission: 'controls:read',
  },
};

export const EditChillerRoute = {
  path: 'edit-chiller/:controlId',
  name: 'EditChiller',
  props: true,
  component: EditChiller,
  meta: {
    label: 'Edit Chiller',
    toolTip: 'Edit Chiller',
    permission: 'controls:update',
  },
};
